export const GROUP_STAFF = 'staff';
export const GROUP_OWNER = 'owner';
export const GROUP_SUPER = 'super_admin';
export const GROUP_IT= 'it_admin';
export const GROUP_FIELD_SALES_MANAGER = 'field_sales_manager';
export const GROUP_ACCOUNT_MANAGER = 'account_manager';



// WEBPACK FOOTER //
// ./src/data/userGroups.js